import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { GetInvoicesbyitem } from '../store/slices/ledger';
import {Edititems } from '../store/slices/items';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import { toast } from 'react-hot-toast';

const Item = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const { itemid } = useParams();

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [itemName, setItemName] = useState();
  const [columns, setcolumns] = useState([
    { header: 'Item Name', field: 'ItemName' },
    { header: 'Type', field: 'TransactionType' },
    { header: 'Invoice Date', field: 'TransactionDate' },
    { header: 'Invoice Number', field: 'TransactionNumber' },
    {
      header: 'Quantity',
      field: 'Quantity',
      render: (row) => {
        const quantity = row?.Quantity ?? '';
        const unit = row?.Unit || row?.unit || '';
        if (!unit) return quantity;
        return (
          <span style={{ display: 'inline-flex', gap: '6px', alignItems: 'baseline' }}>
            <span>{quantity}</span>
            <span>{unit}</span>
          </span>
        );
      },
    },
    { header: 'Cost', field: 'PricePerUnit' },
    { header: 'Total', field: 'sub_total' },
    { header: 'GST', field: 'tax_amount' },
    { header: 'Grand Total', field: 'TotalCost' },
    { header: 'Party Name', field: 'PartyName' },
    {
      header: 'Actions',
      field: 'actions',
      isAction: true,
      actionButtons: [{ name: 'View Invoice', className: 'btn-default' }],
    },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

// Load saved financial year and dates from localStorage
  const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem("selectedFinancialYear");

    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes("-")) {
      [startYear, endYear] = savedFinancialYear.split("-");
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear; // Example: 2025 (for 2024-2025)
    }

    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem("savedFromDate") || `${startYear}-04-01`,
      toDate: localStorage.getItem("savedToDate") || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };

  const {
    fromDate: initialFromDate,
    toDate: initialToDate,
    minDate,
    maxDate,
    financialYear: initialFinancialYear,
  } = loadSavedDates();

const [fromDate, setFromDate] = useState(initialFromDate);
const [toDate, setToDate] = useState(initialToDate);
const [financialYear, setFinancialYear] = useState(initialFinancialYear);


useEffect(() => {
  if (!financialYear) return;

  localStorage.setItem('selectedFinancialYear', financialYear);

  let startYear, endYear;
  if (financialYear.includes('-')) {
    [startYear, endYear] = financialYear.split('-');
  } else {
    return; // Exit if financial year is not valid
  }

  const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
  const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;

  setFromDate(savedFromDate);
  setToDate(savedToDate);

  if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
  if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
}, [financialYear]);





  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    if (item.TransactionType == 'Purchase' && item.TransactionType) {
      navigate(`/purchase/editpurchasevoucher/${item.id ? item.id : null}`);
    } else if (item.TransactionType == 'Sale' && item.TransactionType) {
      navigate(`/Updateaddinvoice/${item.id ? item.id : null}`);
    }
  };

    useEffect(() => {
      if (itemid && id) {
        setIsLoading(true);
        dispatch(Edititems({ profile_id: id, item_id: itemid })) 
          .unwrap()
          .then((data) => {
            setIsLoading(false);
            const item = data?.data;
            setItemName(item?.name || '');
          })
          .catch(({ message }) => {
            setIsLoading(false);
            console.log(message);
          });
      }
    }, []);
  useEffect(() => {
    handleItemLedger();
  }, [financialYear]);

  const handleItemLedger = async () => {
    const newItem = {
      profile_id: id,
      from_date: fromDate,
      to_date: toDate,
      item_id: itemid,
    };

    console.log('Request Payload:', newItem); // Debugging log

    setIsLoading(true);

    try {
      const data = await dispatch(GetInvoicesbyitem(newItem)).unwrap();
      console.log('API Response:', data); // Debugging log
      setItemList(data?.item_ledger || []);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Error fetching data');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filtereditemList = itemList?.filter(
    (party) =>
      party?.ItemName?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.TransactionType?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.TransactionDate?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.TransactionNumber?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      String(party?.Quantity || '')
        .toLowerCase()
        ?.includes(searchQuery?.toLowerCase()) ||
      String(party?.PricePerUnit || '')
        .toLowerCase()
        ?.includes(searchQuery?.toLowerCase()) ||
      String(party?.TotalCost || '')
        .toLowerCase()
        ?.includes(searchQuery?.toLowerCase()) ||
      party?.PartyName?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );
 // Handle date changes with validation
 const handleFromDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setFromDate(newDate);
    localStorage.setItem('savedFromDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const handleToDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setToDate(newDate);
    localStorage.setItem('savedToDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const formatFinancialYear = (startDate, endDate) => {
  return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
};

  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Item Ledger List</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Item</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {itemName}
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn ripple btn-default" onClick={() => navigate(-1)}>
                Back
              </button>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4 form-inline">
                      <div class="form-group">
                        <label class="">From Date</label>
                        <input class="form-control" type="date" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate}  />
                      </div>
                    </div>
                    <div class="col-md-4 form-inline">
                      <div class="form-group">
                        <label class="">To Date</label>
                        <input class="form-control" type="date" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate} />
                      </div>
                    </div>
                    <div class="col-md-3 form-inline">
                      <div class="form-group">
                        <button type="submit" class="btn btn-default" onClick={() => handleItemLedger()}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filtereditemList}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filtereditemList?.length}
                onPageChange={handlePageChange}
                handleSearchChange={handleSearchChange}
                handleView={handleEdit}
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Item;
